import { useBoundStore } from 'useStore';
import PvpShippingCell from './PvpShippingCell';
import { useShallow } from 'zustand/react/shallow';
import { useContext } from 'react';
import { AppGlobalContext } from 'contexts/GlobalContext';

export default function ProjectedPvpField({
	pvp,
	freeshipping,
	freeshippingCost,
	id,
}) {
	const { mainCountry } = useContext(AppGlobalContext);
	const countryName = mainCountry?.pais;
	const editedRow = useBoundStore(
		useShallow((state) => state.pricingEditedRows[id])
	);

	const editedFreeshipping = editedRow?.freeshipping_proyectado ?? freeshipping;
	// El proyectado puede traer un costo distinto (override desde MELI cuando el costo base es 0).
	const editedFreeshippingCost =
		editedRow?.freeshippingcostc_proyectado ??
		editedRow?.freeshippingcostc ??
		freeshippingCost;

	return (
		<PvpShippingCell
			pvp={pvp}
			freeshipping={editedFreeshipping}
			freeshippingCost={editedFreeshippingCost}
			countryName={countryName}
		/>
	);
}
